import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Switch,
  ThemeProvider,
} from "@mui/material";
import { Delete, Add } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import ApiService from "../../../../components/apiService/ApiService";
import styles from "./billingDetails.module.css";
import parentStyles from "../Details/details.module.css";
import CustomSnackbar from "../../../../components/ui/CustomSnackbar/customSnackbar";
import CustomModal from "../../../../components/ui/CustomModal/customModal";
import { Button, FormControl } from "@mui/material";
import Locations from "../../../../components/vnLocations/locations";
import DownloadIcon from "@mui/icons-material/Download";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import SubscriptionActivationModal from "./Modals/SubscriptionActivation/SubscriptionActivation";
import { styled, useTheme } from "@mui/material/styles";
import UpdatePlanModal from "./Modals/UpdatePlan/UpdatePlanModal";
import UpdateCreditAddonModal from "./Modals/UpdateCreditAddon/UpdateCreditAddonModal";

const statusOptions = [
  "TRIAL",
  "TRIAL_EXPIRED",
  "PRE_ACTIVATION",
  "ACTIVE",
  "INACTIVE",
  "PAUSED",
  "SUSPENDED_UCC",
  "SUSPENDED_DOCS",
  "AUTO_CANCELLED"
];

const creditAddonTypeOptions = {
  per_org: "Per org",
  per_user: "Per plan license",
};

const planOptions = [
  "Standard-INR-Monthly",
  "Standard-INR-Every-3-months",
  "Standard-INR-Half-yearly",
  "Standard-INR-Yearly",
  "Professional-INR-Trial",
  "Professional-INR-Monthly",
  "Professional-INR-Every-3-months",
  "Professional-INR-Half-yearly",
  "Professional-INR-Yearly",
  "Standard-USD-Monthly",
  "Standard-USD-Every-3-months",
  "Standard-USD-Half-yearly",
  "Standard-USD-Yearly",
  "Professional-USD-Trial",
  "Professional-USD-Monthly",
  "Professional-USD-Every-3-months",
  "Professional-USD-Half-yearly",
  "Professional-USD-Yearly",
  "Standard-USD-Monthly-UAE",
  "Standard-USD-Every-3-months-UAE",
  "Standard-USD-Half-yearly-UAE",
  "Standard-USD-Yearly-UAE",
  "Professional-USD-Trial-UAE",
  "Professional-USD-Monthly-UAE",
  "Professional-USD-Every-3-months-UAE",
  "Professional-USD-Half-yearly-UAE",
  "Professional-USD-Yearly-UAE",
];

function generateVnAddonCode(country, vnType, isIncludedInPlan) {
  const normalize = (value) => String(value).replace(/\s+/g, "").toLowerCase();

  const parts = [
    "vn",
    country ? normalize(country) : undefined,
    vnType ? normalize(vnType) : undefined,
    isIncludedInPlan ? "free" : undefined,
  ];

  return parts.filter(Boolean).join("_");
}

function removeUnderscoreLabel(str) {
  return String(str || "")
    .trim()
    .split("_")
    .filter(Boolean)
    .join(" ");
}

function BillingDetails(props) {
  let { accountId } = useParams();
  const theme = useTheme();

  const [slabBasedPricing, setSlabBasedPricing] = useState();
  const [slabsDiscountData, setSlabsDiscountData] = useState({});
  const [details, setDetails] = useState(null);
  const [planLicenses, setPlanLicenses] = useState("");
  const [status, setStatus] = useState("");
  const [paymentDueDate, setPaymentDueDate] = useState("");
  const [subStartDate, setSubStartDate] = useState("");
  const [subEndDate, setSubEndDate] = useState("");
  const [gracePeriod, setGracePeriod] = useState(0);
  const [zohoSubscriptionId, setZohoSubscriptionId] = useState("");
  const [zohoCustomerId, setZohoCustomerId] = useState("");
  const [credits, setCredits] = useState(null);
  const [credit_addon, setCreditAddon] = useState(null);
  const [credit_addon_type, setCreditAddonType] = useState(null);
  const [autoCharge, setAutoCharge] = useState(null);
  const [discounts, setDiscounts] = useState({});
  const [trialLocation, setTrialLocation] = useState(null);
  const [response, setResponse] = useState({});
  const [showTrialModal, setShowTrialModal] = useState(false);
  const [trialEndDate, setTrialEnddate] = useState(null);
  const [showTrialExtensionModal, setShowTrialExtensionModal] = useState(false);
  const [showActivateSubsModal, setShowActivateSubsModal] = useState(false);
  const [showUpdatePlanModal, setShowUpdatePlanModal] = useState(false);
  const [showUpdateCreditAddonModal, setShowUpdateCreditAddonModal] =
    useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [isSaveButtonEnabled, setSaveButtonEnabled] = useState(false);
  const [updatePayload, setUpdatePayload] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [showManageModal, setShowManageModal] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState("Plan");
  const [selectedAction, setSelectedAction] = useState("add");
  const [selectedQuantity, setSelectedQuantity] = useState();
  const [isTrialPermission, setIsTrialPermission] = useState();
  const [isSubscriptionPermission, setIsSubscriptionPermission] = useState();
  const [plan, setPlan] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [countries, setCountries] = useState([]);
  const [vnData, setVnData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("India");
  const [selectedNumberType, setSelectedNumberType] = useState("STANDARD");
  const [customerId, setCustomerId] = useState(null);

  const [discountModal, setDiscountModal] = useState(false);
  const [planType, setPlanTye] = useState("free");
  const [discountValue, setDiscountValue] = useState(0);
  const [showLoaderDiscountModal, setShowLoaderDiscountModal] = useState(false);
  const [isSubmittingDiscountModal, setIsSubmittingDiscountModal] =
    useState(false);

  const notifyAutoCancelled = (status) => {
    if (status === 'AUTO_CANCELLED') {
      setResponse({
        message: "Subscription cannot be updated as it is auto cancelled",
        success: false,
      });
      setShowSnackbar(true);
      return true;
    }
    return false;
  };

  const handleDiscardChanges = (details) => {
    setDisabled(true);
    updateDetails(details);
    setUpdatePayload({});
    setSaveButtonEnabled(false);
  };
  const handleManageModal = () => {
    if (notifyAutoCancelled(status)) return;
    setShowManageModal((prev) => !prev);
    setSelectedAction("add");
    setSelectedLicense("Plan");
    setSelectedQuantity(null);
  };

  const handleInitiateTrial = () => {
    const locationId = trialLocation ? trialLocation.id : null;
    const payload = {
      location: locationId,
    };
    if (customerId) {
      payload["customer_id"] = customerId;
    }

    ApiService.post(`api/v1/dashboard/initiate-trial/${accountId}/`, payload)
      .then((response) => {
        handleFeedback(response);
        setShowTrialModal(false);
      })
      .catch((response) => {
        handleFeedback(response.success);
      });
  };

  const handleExtendTrial = async () => {
    try {
      if (new Date().setHours(0, 0, 0, 0) > new Date(trialEndDate)) {
        setResponse({
          success: false,
          message: "New trial end date should not be in past",
        });
        setShowSnackbar(true);
        return;
      }
      const payload = {
        renewal_date: trialEndDate,
      };
      const response = await ApiService.post(
        `api/v1/dashboard/extend-trial/${accountId}/`,
        payload,
      );
      handleFeedback(response);
      setShowTrialExtensionModal(false);
    } catch (err) {
      console.log(JSON.stringify(err));
      handleFeedback(response.success);
    }
  };

  const handleFeedback = (response) => {
    if (response) {
      setResponse(response.data);
    } else {
      setResponse({
        message: "Unexpected Error. Please Try Again",
        success: false,
      });
    }
    setShowSnackbar(true);
  };

  function sanitizeSlabsDiscountData(discountData) {
    if (!discountData?.plans?.slabs) return discountData;
    return {
      ...discountData,
      plans: {
        ...discountData.plans,
        slabs: discountData.plans.slabs.map((slab) => ({
          min_plans: Number(slab.min_plans),
          discount: Number(slab.discount),
        })),
      },
    };
  }

  const handleSaveChanges = (_zohoCustomerId = null) => {
    if (notifyAutoCancelled(status)) return;
    let payload = {
      ...updatePayload,
      slab_based_discounts: sanitizeSlabsDiscountData(slabsDiscountData),
    };

    if (_zohoCustomerId) {
      payload = { ...payload, zoho_customer_id: _zohoCustomerId };
    }
    ApiService.patch(
      `/api/v1/dashboard/update-subscription/${accountId}/`,
      payload,
    )
      .then((res) => {
        setDisabled(true);
        updateDetails(res?.data?.data);
        setDetails(res.data.data);
        setUpdatePayload({});
        setSaveButtonEnabled(false);
        setShowSnackbar(true);
        setResponse({
          message: "Subscription will be updated shortly",
          success: true,
        });
      })
      .catch((error) => {
        handleFeedback(error.response);
      });
  };

  const handleInputChange = (category, key, value) => {
    let temp = {};
    if (category === "VIRTUAL NUMBER") {
      temp = {
        ...updatePayload,
        discounts: {
          ...updatePayload["discounts"],
          [category]: {
            ...updatePayload["discounts"]?.[category],
            ...discounts?.addons["VIRTUAL NUMBER"],
            [key]: parseFloat(value),
          },
        },
      };

      setDiscounts((prevData) => ({
        ...prevData,
        addons: {
          ...prevData.addons,
          [category]: {
            ...prevData.addons[category],
            [key]: parseFloat(value),
          },
        },
      }));
    } else {
      temp = {
        ...updatePayload,
        discounts: {
          ...updatePayload["discounts"],
          [key]: parseFloat(value),
        },
      };

      setDiscounts((prevData) => ({
        ...prevData,
        [category]: {
          ...prevData[category],
          [key]: parseFloat(value),
        },
      }));
    }
    setUpdatePayload(temp);
  };

  const updateDetails = (data) => {
    setPaymentDueDate(data?.payment_due_date);
    setSubStartDate(data?.start_date);
    setSubEndDate(data?.end_date);
    setGracePeriod(data?.grace_period);
    setCredits(data?.credit?.balance);
    setCreditAddon(data?.credit_addon?.credit_amount);
    setCreditAddonType(data?.credit_addon?.credit_allocation_type);
    setAutoCharge(data?.auto_charge);
    setStatus(data?.status);
    setZohoSubscriptionId(data?.zoho_subscription_id);
    setZohoCustomerId(data?.zoho_customer_id);
    const licensesData = {};
    data?.licenses.forEach((license) => {
      licensesData[license.type] = {
        total: license.total,
        free: license.free,
        deleted: license.deleted,
        discountedPrice: license.discounted_price,
        proratedPrice: license.prorated_price,
      };
    });
    setPlanLicenses(licensesData);
    setDiscounts(data?.discounts);
    setPlan(data?.plan);
    setSlabBasedPricing(data?.slab_based_pricing ?? false);
    setSlabsDiscountData(data?.slab_based_discounts ?? {});
  };

  const handleUpdateLicenses = () => {
    const payload = {
      action: selectedAction,
      license: selectedLicense,
      quantity: selectedQuantity,
    };

    ApiService.post(`/api/v1/dashboard/update-licenses/${accountId}/`, payload)
      .then((response) => {
        handleFeedback(response);
        setShowManageModal(false);
        setSelectedAction("add");
        setSelectedQuantity("");
        setSelectedLicense("Plan");
      })
      .catch((error) => {
        handleFeedback(error.response);
      });
  };

  const updateVnLicenseHandler = () => {
    if (!selectedQuantity || !selectedCountry || !selectedNumberType) return;
    const payload = {
      action: "add",
      quantity: selectedQuantity,
      vn_addon_country: selectedCountry,
      vn_addon_type: selectedNumberType,
    };

    ApiService.post(
      `/api/v1/dashboard/update-vn-licenses/${accountId}/`,
      payload,
    )
      .then((response) => {
        handleFeedback(response);
      })
      .catch((error) => {
        handleFeedback(error.response);
      })
      .finally(() => {
        setShowManageModal(false);
        setSelectedAction("add");
        setSelectedQuantity("");
        setSelectedLicense("Plan");
        setSelectedCountry("India");
        setSelectedNumberType("STANDARD");
      });
  };

  const handleDownloadCreditUsageReport = async () => {
    setShowLoader(true);
    try {
      const res = await ApiService.get(
        `/api/v1/dashboard/download-report/${accountId}/?date_start=${startDate}&date_end=${endDate}&report=credit`,
      );
      if (res.data.success) {
        handleFeedback(res);
      } else {
        throw new Error(
          res.data.message || "Error while generating credit usage report",
        );
      }
    } catch (err) {
      handleFeedback(err.response);
    } finally {
      setShowLoader(false);
    }
  };

  const handleUpdateAutoCharge = async (e) => {
    if (notifyAutoCancelled(status)) return;
    const next = e?.target?.checked ?? !autoCharge;
    setAutoCharge(next);
    try {
      const res = await ApiService.patch(
        `/api/v1/dashboard/update-subscription/${accountId}/`,
        { auto_charge: next },
      );
      if (!res?.data?.success) {
        throw new Error(
          res?.data?.message || "Failed to update auto charge setting",
        );
      }
      setResponse({
        message: res?.data?.message || "Auto charge setting updated",
        success: true,
      });
      setShowSnackbar(true);
    } catch (err) {
      setAutoCharge(!next);
      setResponse({
        message: err?.response?.data?.message || "Failed to update auto charge",
        success: false,
      });
      setShowSnackbar(true);
    }
  };

  const handleSlabChange = (index, field, value) => {
    if (!isSubscriptionPermission) return;
    setSlabsDiscountData((prev) => {
      const updated = {
        ...prev,
        plans: {
          ...prev.plans,
          slabs: prev.plans.slabs.map((slab, i) =>
            i === index ? { ...slab, [field]: value } : slab,
          ),
        },
      };
      return updated;
    });
    setDisabled(false);
  };

  const handlePlanStatusChange = (e) => {
    const newStatus = e.target.value;
    if (notifyAutoCancelled(status)) return;
    if (details?.status === "TRIAL" && newStatus === "ACTIVE") {
      setResponse({
        message:
          "Click on 'Activate subscription' button to correctly upgrade account",
        success: false,
      });
      setDisabled(true);
      setShowSnackbar(true);
      return;
    }
    setDisabled(false);
    setStatus(newStatus);
    const temp = updatePayload;
    temp["status"] = newStatus;
    setUpdatePayload(temp);
  };

  const fetchData = (accountId, showFeedback = true) => {
    setShowLoader(true);
    ApiService.get(`/api/v1/dashboard/retrieve-subscription/${accountId}/`)
      .then((res) => {
        if (res.data.success) {
          setDetails(res.data.data);
          updateDetails(res.data.data);
          const trialPermission = res.data.data["trial_subscription.can_write"];
          setIsTrialPermission(trialPermission);
          const subscriptionPermission =
            res.data.data["subscriptions.can_write"];
          setIsSubscriptionPermission(subscriptionPermission);
          const today = Date.now();
          setStartDate(
            res.data.data?.start_date || new Date(today - 7 * 864000000),
          );
          setEndDate(res.data.data?.end_date || new Date(today));
        }
        setShowLoader(false);
        if (showFeedback) handleFeedback(res);
      })
      .catch((err) => {
        setShowLoader(false);
        handleFeedback(err.response);
      });
  };

  useEffect(() => {
    fetchData(accountId);
  }, [accountId]);

  useEffect(() => {
    if (selectedLicense === "Virtual Number") {
      ApiService.get(`/api/v1/dashboard/retrieve-vn-pricing/${accountId}/`)
        .then((response) => {
          handleFeedback(response);
          setVnData(response?.data?.data?.pricing || []);
          setCountries(
            response?.data?.data?.pricing?.map((l, id) => {
              return { id: id, name: l.country };
            }) || [],
          );
        })
        .catch((error) => {
          console.error("Retrieve vn pricing error = ", error);
          handleFeedback(error.response);
        });
    }
  }, [selectedLicense, accountId]);

  useEffect(() => {
    if (discountModal) {
      setShowLoaderDiscountModal(true);
      ApiService.get(`/api/v1/dashboard/retrieve-vn-pricing/${accountId}/`)
        .then((response) => {
          setVnData(response?.data?.data?.pricing || []);
          setCountries(
            response?.data?.data?.pricing?.map((l, id) => {
              return { id: id, name: l.country };
            }) || [],
          );
          setShowLoaderDiscountModal(false);
        })
        .catch((error) => {
          console.error("Retrieve vn pricing error = ", error);
          setShowLoaderDiscountModal(false);
        });
    } else {
      setCountries([]);
      setVnData([]);
    }
  }, [discountModal, accountId]);

  const handleAddVNDiscount = () => {
    let category = "VIRTUAL NUMBER";
    let key = generateVnAddonCode(
      selectedCountry,
      selectedNumberType,
      planType === "free",
    );

    let currentVN = discounts.addons?.[category] ?? {};
    currentVN = {
      ...currentVN,
      [key]: Number(discountValue || 0),
    };

    const newPayload = {
      discounts: {
        "VIRTUAL NUMBER": { ...currentVN },
      },
    };

    updateVNDiscount(null, newPayload);
  };

  const handleDeleteVNDiscount = (id) => {
    let category = "VIRTUAL NUMBER";
    // 1) compute next state slice from current state
    const currentVN = discounts.addons?.[category] ?? {};
    const { [id]: _removed, ...nextVN } = currentVN;

    // 2) update state using computed object
    setDiscounts((prev) => ({
      ...prev,
      addons: {
        ...(prev.addons ?? {}),
        [category]: nextVN,
      },
    }));

    // 3) build payload + call API using the computed object
    setUpdatePayload((prev) => {
      return {
        ...prev,
        discounts: {
          "VIRTUAL NUMBER": { ...nextVN },
        },
      };
    });
  };

  const updateVNDiscount = (_zohoCustomerId = null, newPayload) => {
    if (notifyAutoCancelled(status)) return;
    setIsSubmittingDiscountModal(true);
    let payload = {
      ...newPayload,
      slab_based_discounts: sanitizeSlabsDiscountData(slabsDiscountData),
    };
    if (_zohoCustomerId) {
      payload = { ...payload, zoho_customer_id: _zohoCustomerId };
    }

    ApiService.patch(
      `/api/v1/dashboard/update-subscription/${accountId}/`,
      payload,
    )
      .then((res) => {
        setResponse({
          message: "Discount added",
          success: true,
        });

        setDiscounts((prev) => {
          return {
            ...prev,
            addons: {
              ...res?.data?.data.discounts.addons,
              "VIRTUAL NUMBER": {
                ...res?.data?.data.discounts.addons["VIRTUAL NUMBER"],
              },
            },
          };
        });
        fetchData(accountId);
      })
      .catch((error) => {
        handleFeedback(error.response);
      })
      .finally(() => {
        setSelectedCountry("India");
        setSelectedNumberType("STANDARD");
        setPlanTye("free");
        setDiscountModal(false);
        setIsSubmittingDiscountModal(false);
        setDiscountValue(0);
      });
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const virtualNumber = discounts?.addons?.["VIRTUAL NUMBER"];
  return (
    <div>
      {showLoader ? (
        <div className={styles.loader_wrapper}>
          <CircularProgress color="success" size={60} />
        </div>
      ) : (
        <div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              gap: "1em",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{ flex: "1 1 250px", minWidth: 250 }}
              className={parentStyles.accountSettings}
            >
              <label className={parentStyles.mainheading}>Subscription</label>
              <div className={parentStyles.property}>
                <label>Plan</label>
                <select value={plan || ""} disabled={true}>
                  <option value="" disabled hidden>
                    None
                  </option>
                  {planOptions.map((plan) => {
                    return (
                      <option key={plan} value={plan}>
                        {plan}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className={parentStyles.property}>
                <label>Plan Status</label>
                <select
                  value={status}
                  onChange={handlePlanStatusChange}
                  disabled={!isSubscriptionPermission}
                >
                  {statusOptions.map((elem) => {
                    return <option value={elem} disabled={elem === "AUTO_CANCELLED"}>{elem}</option>;
                  })}
                </select>
              </div>
              <div className={parentStyles.property}>
                <label>Start date</label>
                <div className={parentStyles.clm}>
                  <input
                    type="date"
                    name="subs_start_date"
                    value={subStartDate}
                    onChange={(e) => {
                      setDisabled(false);
                      setSubStartDate(e.target.value);
                      const temp = updatePayload;
                      temp["start_date"] = e.target.value;
                      setUpdatePayload(temp);
                    }}
                    disabled={!isSubscriptionPermission}
                  />
                </div>
              </div>
              <div className={parentStyles.property}>
                <label>End date</label>
                <div className={parentStyles.clm}>
                  <input
                    type="date"
                    name="subs_end_date"
                    value={subEndDate}
                    onChange={(e) => {
                      setDisabled(false);
                      setSubEndDate(e.target.value);
                      const temp = updatePayload;
                      temp["end_date"] = e.target.value;
                      setUpdatePayload(temp);
                    }}
                    disabled={!isSubscriptionPermission || ["SUSPENDED_UCC", "SUSPENDED_DOCS", "AUTO_CANCELLED"].includes(details?.status)}
                  />
                </div>
              </div>
              <div className={parentStyles.property}>
                <label>Payment due date</label>
                <input
                  type="date"
                  name="payment_due_date"
                  value={paymentDueDate}
                  disabled={!["ACTIVE", "INACTIVE"].includes(details?.status)}
                  onChange={(e) => {
                    setDisabled(false);
                    setPaymentDueDate(e.target.value);
                    const temp = updatePayload;
                    temp["payment_due_date"] = e.target.value;
                    setUpdatePayload(temp);
                  }}
                />
                <label>Grace period (Payment terms)</label>
                <input
                  type="number"
                  name="grace_period"
                  value={gracePeriod}
                  onChange={(e) => {
                    setGracePeriod(e.target.value);
                    const temp = updatePayload;
                    temp["grace_period"] = parseInt(e.target.value, 10);
                    setUpdatePayload(temp);
                    setDisabled(false);
                  }}
                  disabled={[
                    "TRIAL",
                    "PRE_ACTIVATION",
                    "TRIAL_EXPIRED",
                    "AUTO_CANCELLED"
                  ].includes(details?.status)}
                />
              </div>
              <div className={parentStyles.property}>
                <label>Zoho Subscription ID</label>
                <input
                  type="text"
                  name="zoho_subscription_id"
                  value={zohoSubscriptionId}
                  onChange={(e) => {
                    setZohoSubscriptionId(e.target.value);
                    const temp = updatePayload;
                    temp["zoho_subscription_id"] = e.target.value;
                    setUpdatePayload(temp);
                    setDisabled(false);
                  }}
                  disabled={!isSubscriptionPermission}
                />
              </div>
              <div className={parentStyles.property}>
                <label>Zoho Customer ID</label>
                <input
                  type="text"
                  name="zoho_customer_id"
                  value={zohoCustomerId}
                  onChange={(e) => {
                    setZohoCustomerId(e.target.value);
                    const temp = updatePayload;
                    temp["zoho_customer_id"] = e.target.value;
                    setUpdatePayload(temp);
                    setDisabled(false);
                  }}
                  disabled={!isSubscriptionPermission}
                />
              </div>
              <div className={parentStyles.property}>
                <ThemeProvider theme={theme}>
                  <FormGroup>
                    <FormControlLabel
                      value={autoCharge}
                      style={{ height: "20px" }}
                      control={
                        <IOSSwitch
                          checked={autoCharge}
                          onChange={handleUpdateAutoCharge}
                          sx={{ m: 1 }}
                          defaultChecked
                        />
                      }
                      label="Auto Charge"
                      labelPlacement="end"
                    />
                  </FormGroup>
                </ThemeProvider>
              </div>
            </div>
            <div
              style={{ flex: "1 1 500px", minWidth: 500 }}
              className={parentStyles.accountSettings}
            >
              <div
                className={parentStyles.settings}
                style={{ alignItems: "center", width: "492px" }}
              >
                <label className={parentStyles.mainheading}>
                  Licenses
                  <Button
                    sx={{ color: "#34CB65" }}
                    onClick={handleManageModal}
                    disabled={!isSubscriptionPermission}
                  >
                    ( Manage )
                  </Button>
                </label>
                <label>Free vns claimed: {details?.free_vns_claimed}</label>
              </div>
              <br />
              <table className={styles.licenseTable}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Discount Price</th>
                    <th>Prorated Price</th>
                    <th>Total</th>
                    <th>Free</th>
                    <th>Deleted</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(planLicenses).map(
                    ([licenseType, licenseDetails]) => (
                      <tr key={licenseType}>
                        <td>{licenseType}</td>
                        <td>{licenseDetails.discountedPrice}</td>
                        <td>{licenseDetails.proratedPrice}</td>
                        <td>{licenseDetails.total}</td>
                        <td>{licenseDetails.free}</td>
                        <td>{licenseDetails.deleted}</td>
                      </tr>
                    ),
                  )}
                </tbody>
              </table>

              <div className={parentStyles.property}>
                <label>
                  Credit Balance {`(${details?.credit?.currency || ""})`}
                </label>
                <div className={parentStyles.clm}>
                  <input
                    type="text"
                    name="credit_balance"
                    value={credits}
                    onChange={(e) => {
                      setCredits(e.target.value);
                      const temp = updatePayload;
                      temp["credit"] = e.target.value;
                      setUpdatePayload(temp);
                      setDisabled(false);
                    }}
                    disabled={!isSubscriptionPermission}
                  />
                </div>
              </div>
              <div className={parentStyles.property}>
                <label>
                  Credit Addon {`(${details?.credit?.currency || ""})`}
                  <Button
                    sx={{ color: "#34CB65" }}
                    onClick={() => {
                      if (notifyAutoCancelled(status)) return;
                      setShowUpdateCreditAddonModal(true)}}
                    disabled={!isSubscriptionPermission}
                  >
                    ( Manage )
                  </Button>
                </label>

                <div className={parentStyles.clm}>
                  <input
                    type="text"
                    name="credit_addon"
                    value={credit_addon}
                    disabled={true}
                  />

                  <select
                    style={{
                      marginLeft: "10px",
                    }}
                    value={credit_addon_type}
                    disabled={true}
                  >
                    {Object.entries(creditAddonTypeOptions).map(
                      ([val, label]) => {
                        return (
                          <option value={val} key={val}>
                            {label}
                          </option>
                        );
                      },
                    )}
                  </select>
                </div>
              </div>
              <div className={styles.reportDownload}>
                <label>Credit Usage Report</label>
                <div className={parentStyles.clm}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateRangePicker
                      sx={localStyles.dateRange}
                      slots={{ field: SingleInputDateRangeField }}
                      value={[dayjs(startDate), dayjs(endDate)]}
                      onChange={(newValue) => {
                        setStartDate(newValue[0].format("YYYY-MM-DD"));
                        setEndDate(newValue[1].format("YYYY-MM-DD"));
                      }}
                    />
                  </LocalizationProvider>
                  <Button
                    size="small"
                    sx={{
                      bgcolor: "#34cb65",
                      marginLeft: "5px",
                      height: "44px",
                      marginTop: "2px",
                      ":hover": {
                        bgcolor: "#28994B",
                        color: "white",
                      },
                    }}
                    variant="contained"
                    disabled={!startDate || !endDate}
                    onClick={handleDownloadCreditUsageReport}
                  >
                    <DownloadIcon />
                  </Button>
                </div>
              </div>
            </div>
            <div
              style={{ flex: "1 1 350px", minWidth: 350 }}
              className={parentStyles.accountSettings}
            >
              <label className={parentStyles.mainheading}>Discounts</label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "2em",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <em>virtual Number</em>
                    <Button
                      sx={{
                        bgcolor: "#36cb64",
                        color: "white",
                        ":hover": {
                          bgcolor: "#28994B",
                        },
                        padding: "3px",
                        marginLeft: "8px",
                      }}
                      startIcon={<Add />}
                      onClick={() => setDiscountModal((prev) => !prev)}
                    >
                      Add
                    </Button>
                  </label>
                  <div
                    style={{
                      height: "100%",
                      overflow: "auto",
                      maxHeight: "200px",
                      marginTop: "4px",
                    }}
                  >
                    {typeof virtualNumber === "object" &&
                      Object.entries(virtualNumber).map(([key, price1]) => {
                        return (
                          <div style={{ display: "flex" }} key={`-${key}`}>
                            <input
                              type="text"
                              value={removeUnderscoreLabel(key)}
                              disabled={true}
                              onChange={(e) => {
                                handleInputChange(
                                  "VIRTUAL NUMBER",
                                  key,
                                  e.target.value,
                                );
                                setDisabled(false);
                              }}
                            />
                            <input
                              type="number"
                              value={price1}
                              style={{ width: "50px" }}
                              onChange={(e) => {
                                handleInputChange(
                                  "VIRTUAL NUMBER",
                                  key,
                                  e.target.value,
                                );
                                setDisabled(false);
                              }}
                              disabled={!isSubscriptionPermission}
                            />
                            {key !== "default" && (
                              <Button
                                startIcon={<Delete />}
                                sx={{
                                  color: "red",
                                }}
                                onClick={() => {
                                  setDisabled(false);
                                  handleDeleteVNDiscount(key);
                                }}
                              />
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>

                {Object.entries(discounts).map(([category, value]) => {
                  return (
                    <div key={category}>
                      <label>
                        <em>{category}</em>
                      </label>

                      {typeof value === "object" ? (
                        Object.entries(value).map(([key, price]) => {
                          if (typeof price === "object") {
                            return null;
                          }
                          return (
                            <div
                              style={{ display: "flex" }}
                              key={`${category}-${key}`}
                            >
                              <input
                                type="text"
                                value={key}
                                onChange={(e) => {
                                  handleInputChange(
                                    category,
                                    key,
                                    e.target.value,
                                  );
                                  setDisabled(false);
                                }}
                                disabled={!isSubscriptionPermission}
                              />
                              <input
                                type="number"
                                value={price}
                                style={{ width: "50px" }}
                                onChange={(e) => {
                                  handleInputChange(
                                    category,
                                    key,
                                    e.target.value,
                                  );
                                  setDisabled(false);
                                }}
                                disabled={!isSubscriptionPermission}
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div>
                          <input
                            type="text"
                            value={category}
                            onChange={(e) => {
                              handleInputChange(
                                category,
                                category,
                                e.target.value,
                              );
                              setDisabled(false);
                            }}
                            disabled={!isSubscriptionPermission}
                          />
                          <input
                            type="number"
                            value={value}
                            style={{ width: "50px" }}
                            onChange={(e) => {
                              handleInputChange(
                                category,
                                category,
                                e.target.value,
                              );
                              setDisabled(false);
                            }}
                            disabled={!isSubscriptionPermission}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}

                <div>
                  <ThemeProvider theme={theme}>
                    <FormGroup>
                      <FormControlLabel
                        value={slabBasedPricing}
                        style={{ height: "20px" }}
                        control={
                          <IOSSwitch
                            checked={slabBasedPricing}
                            onChange={(e) => {
                              setDisabled(false);
                              setSlabBasedPricing(e.target.checked);
                              const temp = updatePayload;
                              temp["slab_based_pricing"] = e.target.checked;
                              setUpdatePayload(temp);
                            }}
                            sx={{ m: 1 }}
                            disabled={!isSubscriptionPermission}
                          />
                        }
                        label="Slab based pricing"
                        labelPlacement="end"
                      />
                    </FormGroup>
                  </ThemeProvider>
                  {slabBasedPricing && (
                    <div className={styles.slabTableContainer}>
                      <h4>Slab based discount</h4>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "600",
                            padding: "8px",
                          }}
                        >
                          Min plan licenses
                        </div>
                        <div
                          style={{
                            fontWeight: "600",
                            padding: "8px",
                          }}
                        >
                          Discount
                        </div>

                        {slabsDiscountData?.plans?.slabs?.map((r, i) => (
                          <React.Fragment key={i}>
                            <input
                              type="text"
                              value={r?.min_plans}
                              onChange={(e) =>
                                handleSlabChange(i, "min_plans", e.target.value)
                              }
                              style={{
                                border: "1px solid #E1E5E2",
                                borderRadius: "4px",
                                padding: "8px 12px",
                                width: "100%",
                                height: "2.7em",
                                boxSizing: "border-box",
                              }}
                            />
                            <input
                              type="text"
                              value={r?.discount}
                              onChange={(e) =>
                                handleSlabChange(i, "discount", e.target.value)
                              }
                              style={{
                                border: "1px solid #E1E5E2",
                                borderRadius: "4px",
                                padding: "8px 12px",
                                width: "100%",
                                height: "2.7em",
                                boxSizing: "border-box",
                              }}
                            />
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={parentStyles.accountSettings}>
            {(!details?.status || details.status === "TRIAL") && !credits && (
              <Button
                className={parentStyles.bts}
                variant="contained"
                style={{
                  fontSize: 14,
                  height: "max-content",
                  marginTop: "10px",
                  marginBottom: "10px",
                  width: "max-content",
                }}
                disabled={
                  (details?.status ? details?.status !== "TRIAL" : false) ||
                  credits
                }
                sx={{
                  bgcolor: "#34cb65",
                  ":hover": {
                    bgcolor: "#28994B",
                    color: "white",
                  },
                }}
                onClick={() => setShowTrialModal(true)}
              >
                Start Trial
              </Button>
            )}
            {["PRE_ACTIVATION", "TRIAL", "TRIAL_EXPIRED"]?.includes(
              details?.status,
            ) && (
              <Button
                className={parentStyles.bts}
                variant="contained"
                style={{
                  fontSize: 14,
                  height: "max-content",
                  marginTop: "10px",
                  marginBottom: "10px",
                  width: "max-content",
                }}
                sx={{
                  bgcolor: "#34cb65",
                  ":hover": {
                    bgcolor: "#28994B",
                    color: "white",
                  },
                }}
                onClick={() => setShowTrialExtensionModal(true)}
              >
                Extend Trial
              </Button>
            )}
            {["PRE_ACTIVATION", "TRIAL", "TRIAL_EXPIRED"]?.includes(
              details?.status,
            ) && (
              <Button
                className={parentStyles.bts}
                variant="contained"
                style={{
                  fontSize: 14,
                  height: "max-content",
                  marginTop: "10px",
                  marginBottom: "10px",
                  width: "max-content",
                }}
                sx={{
                  bgcolor: "#34cb65",
                  ":hover": {
                    bgcolor: "#28994B",
                    color: "white",
                  },
                }}
                onClick={() => setShowActivateSubsModal(true)}
              >
                Activate subscription
              </Button>
            )}
            {details?.status === "ACTIVE" && isSubscriptionPermission && (
              <Button
                className={parentStyles.bts}
                variant="contained"
                style={{
                  fontSize: 14,
                  height: "max-content",
                  marginTop: "10px",
                  marginBottom: "10px",
                  width: "max-content",
                }}
                sx={{
                  bgcolor: "#34cb65",
                  ":hover": {
                    bgcolor: "#28994B",
                    color: "white",
                  },
                }}
                onClick={() => setShowUpdatePlanModal(true)}
              >
                Change Plan
              </Button>
            )}
            <div className={parentStyles.updateButtons}>
              <Button
                color="success"
                disabled={disabled}
                variant="outlined"
                size="medium"
                style={{
                  fontSize: 14,
                  height: "max-content",
                  marginTop: "10px",
                  width: "max-content",
                }}
                onClick={() => handleDiscardChanges(details)}
              >
                Cancel
              </Button>
              <Button
                label="Save"
                color="success"
                variant="contained"
                style={{
                  fontSize: 14,
                  height: "max-content",
                  marginTop: "10px",
                  width: "max-content",
                }}
                sx={{
                  bgcolor: "#34cb65",
                  ":hover": {
                    bgcolor: "lightgreen",
                    color: "white",
                  },
                }}
                disabled={disabled}
                onClick={() => handleSaveChanges()}
              >
                Save
              </Button>
            </div>
            <CustomModal
              heading="Start Trial"
              visible={showTrialModal}
              closeModal={() => setShowTrialModal(false)}
              bodyStyles={{
                width: "380px",
                padding: "2em",
              }}
              body={
                <div className={parentStyles.vnForm}>
                  <label>
                    <FormControl style={{ width: "100%", margin: "auto" }}>
                      Location
                      <Locations setSelectedLocation={setTrialLocation} />
                      <label style={{ marginBottom: "4px" }}>
                        Zoho customer Id (Optional - provide if customer already
                        exists in zoho billing target org, else leave blank)
                      </label>
                      <input
                        type="text"
                        value={customerId}
                        onChange={(e) => setCustomerId(e.target.value)}
                      />
                      <div>
                        <Button
                          sx={{
                            margin: "30px 5px 0",
                            bgcolor: "#36cb64",
                            color: "white",
                            ":hover": {
                              bgcolor: "#28994B",
                            },
                          }}
                          className={parentStyles.button}
                          variant="outlined"
                          onClick={handleInitiateTrial}
                        >
                          Start trial
                        </Button>
                        <Button
                          sx={{
                            margin: "30px 0 0 5px",
                          }}
                          className={parentStyles.button}
                          variant="outlined"
                          color="success"
                          onClick={() => setShowTrialModal(false)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </FormControl>
                  </label>
                </div>
              }
            />
            <CustomModal
              heading="Extend Trial"
              visible={showTrialExtensionModal}
              closeModal={() => setShowTrialExtensionModal(false)}
              bodyStyles={{
                width: "380px",
                padding: "2em",
              }}
              body={
                <div>
                  <label className={styles.flexColumn}>
                    <span>Trial End Date: </span>
                    <input
                      type="date"
                      value={trialEndDate}
                      onChange={(e) => setTrialEnddate(e.target.value)}
                    />
                  </label>
                  <div className={styles.btnContainer}>
                    <Button
                      sx={{
                        margin: "30px 5px",
                        bgcolor: "#36cb64",
                        color: "white",
                        ":hover": {
                          bgcolor: "#28994B",
                        },
                      }}
                      className={parentStyles.button}
                      variant="outlined"
                      onClick={handleExtendTrial}
                    >
                      Extend trial
                    </Button>
                    <Button
                      sx={{
                        margin: "30px 5px",
                      }}
                      className={parentStyles.button}
                      variant="outlined"
                      color="success"
                      onClick={() => setShowTrialExtensionModal(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              }
            />
            <SubscriptionActivationModal
              visible={showActivateSubsModal}
              setVisible={setShowActivateSubsModal}
              accountId={accountId}
              currentPlanCurrency={
                details?.plan?.includes("USD")
                  ? "USD"
                  : details?.plan?.includes("INR")
                    ? "INR"
                    : null
              }
              plans={planOptions}
            />
            <UpdatePlanModal
              visible={showUpdatePlanModal}
              setVisible={setShowUpdatePlanModal}
              curPlan={details?.plan}
              plans={planOptions}
              currentPlanCurrency={
                details?.plan?.includes("USD")
                  ? "USD"
                  : details?.plan?.includes("INR")
                    ? "INR"
                    : null
              }
              accountId={accountId}
            />
            <UpdateCreditAddonModal
              visible={showUpdateCreditAddonModal}
              setVisible={setShowUpdateCreditAddonModal}
              currentPlanCurrency={
                details?.plan?.includes("USD")
                  ? "USD"
                  : details?.plan?.includes("INR")
                    ? "INR"
                    : null
              }
              accountId={accountId}
              credit_addon={credit_addon}
              credit_addon_type={credit_addon_type}
            />

            <CustomModal
              heading="Add new discount for virtual number"
              visible={discountModal}
              closeModal={() => setDiscountModal(false)}
              bodyStyles={{
                width: "380px",
                padding: "2em",
              }}
              body={
                <div>
                  {!showLoaderDiscountModal ? (
                    countries?.length > 0 ? (
                      <label className={styles.flexColumn}>
                        <>
                          <label>Country</label>
                          <select
                            value={selectedCountry}
                            onChange={(e) => setSelectedCountry(e.target.value)}
                          >
                            {countries?.map((c) => (
                              <option key={c.id}>{c.name}</option>
                            ))}
                          </select>
                          {selectedCountry && (
                            <>
                              <label>Number type</label>
                              <select
                                value={selectedNumberType}
                                onChange={(e) =>
                                  setSelectedNumberType(e.target.value)
                                }
                              >
                                {vnData
                                  ?.find((v) => v.country === selectedCountry)
                                  ?.number_types?.map((nt) => (
                                    <option>{nt.type}</option>
                                  ))}
                              </select>
                            </>
                          )}

                          <label>Plan</label>
                          <select
                            value={planType}
                            onChange={(e) => setPlanTye(e.target.value)}
                          >
                            <option key="free">Free</option>
                            <option key="paid">Paid</option>
                          </select>
                          <label>Discount</label>
                          <input
                            type="number"
                            value={discountValue}
                            onChange={(e) =>
                              setDiscountValue(parseInt(e.target.value))
                            }
                            style={{ marginTop: "10px" }}
                          />
                        </>
                      </label>
                    ) : (
                      <p style={{ textAlign: "Center" }}>
                        Try to contact frejun.
                      </p>
                    )
                  ) : (
                    <div className={styles.loader_wrapper}>
                      <CircularProgress color="success" size={60} />
                    </div>
                  )}
                  <div className={styles.btnContainer}>
                    <Button
                      sx={{
                        margin: "30px 5px",
                        bgcolor: "#36cb64",
                        color: "white",
                        ":hover": {
                          bgcolor: "#28994B",
                        },
                      }}
                      className={parentStyles.button}
                      variant="outlined"
                      disabled={
                        countries?.length === 0 ||
                        showLoaderDiscountModal ||
                        isSubmittingDiscountModal
                      }
                      onClick={handleAddVNDiscount}
                    >
                      {isSubmittingDiscountModal ? (
                        <CircularProgress color="success" size={25} />
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      sx={{
                        margin: "30px 5px",
                      }}
                      className={parentStyles.button}
                      variant="outlined"
                      color="success"
                      onClick={() => setDiscountModal(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      )}

      <CustomModal
        heading="Manage Licenses"
        visible={showManageModal}
        closeModal={handleManageModal}
        bodyStyles={{
          width: "404px",
        }}
        body={
          <div>
            <div className={styles.vnForm}>
              <div className={styles.MLicences}>
                Select Licenses
                <select
                  onChange={(e) => {
                    setSelectedLicense(e.target.value);
                    if (e.target.value === "Virtual Number") {
                      setSelectedAction("add");
                    }
                  }}
                >
                  <option value="Plan"> Plan</option>
                  <option value="Viewer"> Viewer</option>
                  <option value="Autodial"> Autodial</option>
                  {details?.plan?.includes("INR") && (
                    <option value="Browser Calling">Browser Calling</option>
                  )}
                  <option value="Whatsapp Business">Whatsapp Business</option>
                  {details?.plan?.includes("USD") && (
                    <option value="CNAM">CNAM</option>
                  )}
                  <option value="Virtual Number">Virtual Number Addon</option>
                </select>
              </div>
              <div className={styles.MLicences}>
                Action
                <select onChange={(e) => setSelectedAction(e.target.value)}>
                  <option value="add">Add licenses</option>
                  {selectedLicense !== "Virtual Number" && (
                    <option value="remove">Remove licenses</option>
                  )}
                </select>
                <label>Quantity</label>
                <input
                  type="number"
                  value={selectedQuantity}
                  onChange={(e) =>
                    setSelectedQuantity(parseInt(e.target.value))
                  }
                  style={{ marginTop: "10px" }}
                />
                {selectedLicense === "Virtual Number" &&
                  countries?.length > 0 && (
                    <>
                      <label>Country</label>
                      <select
                        value={selectedCountry}
                        onChange={(e) => setSelectedCountry(e.target.value)}
                      >
                        {countries?.map((c) => (
                          <option key={c.id}>{c.name}</option>
                        ))}
                      </select>
                      {selectedCountry && (
                        <>
                          <label>Number type</label>
                          <select
                            value={selectedNumberType}
                            onChange={(e) =>
                              setSelectedNumberType(e.target.value)
                            }
                          >
                            {vnData
                              ?.find((v) => v.country === selectedCountry)
                              ?.number_types?.map((nt) => (
                                <option>{nt.type}</option>
                              ))}
                          </select>
                        </>
                      )}
                    </>
                  )}
                {selectedAction === "remove" && (
                  <ol>
                    <li className={styles.info}>
                      Licenses will be immediately deleted from database and
                      zoho billing (deletion will not be scheduled for next
                      renewal).
                    </li>
                    <li className={styles.info}>
                      Licenses that are already scheduled for deletion, can not
                      be deleted immediately from here.
                    </li>
                  </ol>
                )}
              </div>
              <div className={styles.actionButton}>
                <Button
                  sx={{
                    bgcolor: "#36cb64",
                    color: "white",
                    // marginLeft: "130px",
                    float: "right",
                    ":hover": {
                      bgcolor: "#28994B",
                    },
                  }}
                  className={parentStyles.button}
                  variant="outlined"
                  onClick={() =>
                    selectedLicense === "Virtual Number"
                      ? updateVnLicenseHandler()
                      : handleUpdateLicenses()
                  }
                  style={{ marginTop: "10px" }}
                >
                  Update Licenses
                </Button>
              </div>
            </div>
          </div>
        }
      />

      {showSnackbar && (
        <CustomSnackbar
          setShowSnackbar={setShowSnackbar}
          message={response.message}
          type={response.success ? "success" : "error"}
          onClose={() => setShowSnackbar(false)}
        />
      )}
    </div>
  );
}

const localStyles = {
  dateRange: {
    minWidth: "45%",
    maxWidth: "65%",
    ".MuiInputBase-input.MuiOutlinedInput-input": {
      padding: "12px",
    },
  },
};

export default BillingDetails;
